<div class="d-flex justify-content-center align-items-center h-25">
  <p>Vous n'avez pas les droits pour accéder à cette page.</p>
</div>
